import { ContentFrameEventMessageArgumentMap } from '../../foreground/types/events';
import PortalGate from '../../PortalGate';
import { CanvasImageHighlight } from '../../quoteshots/CanvasImageGenerator';
import {
  ReadingStickerData,
  StickerTheme,
} from '../../quoteshots/ReadingStickerGenerator';
import { QuoteshotFont, ThemeVariant } from '../../types/quoteshots';
import { Theme } from '../css/baseStyles';
import type { ScrollingManager } from './ScrollingManager';

export interface InitContentFrameProps {
  os: 'ios' | 'android';
  instanceToken: string;
}
export interface MobileContentFrameWindow extends Window {
  theme: Theme;
  s?: ScrollingManager;
  documentLoaded?: boolean;
  deviceWidth?: number;
  isAutoHighlightingEnabled?: boolean;
  initContentFrame?: (props: InitContentFrameProps) => void;
  initCanvasWebview?: () => void;
  initReadingStickerWebview?: () => void;
  renderReadingSticker?: (
    data: ReadingStickerData,
    theme: StickerTheme,
    width: number,
    height: number,
  ) => Promise<void>;
  osType: 'ios' | 'android';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  portalGateToForeground: PortalGate<any, ContentFrameEventMessageArgumentMap>;

  // Methods
  titleClicked: () => void;
  ttsButtonClicked: () => void;
  reloadImagesThatFailedToLoad: () => void;
  drawHighlightOnCanvas?: (
    highlight: CanvasImageHighlight,
    theme: ThemeVariant,
    width: number,
    aspectRatio: number,
    darkMode: boolean,
    currentFont: QuoteshotFont,
  ) => Promise<void>;
  onFaviconError: () => void;
  onFaviconLoaded: () => void;
  onHeaderImageLoaded: () => void;
  onHeaderImageError: () => void;
  onSecondaryHeaderImageLoaded: () => void;
  onSecondaryHeaderImageError: () => void;
  safeAreaMargins?: {top: number; bottom: number;};
  // for easier debugging
  qs?: typeof document.querySelector;
  qsa?: typeof document.querySelectorAll;
  isSlowChunkLoadingEnabled?: boolean;
  isScrollingManagerFPSLoggingEnabled?: boolean;
  isCenteredElementDebugEnabled?: boolean;
  tts?: {ttsAbleElements?: HTMLElement[];};
  destroyContent: () => void;
  _debugCrashWebview: () => void;
}

export const CLICKABLE_TAGS = new Set(['A', 'FIGURE', 'IMG', 'VIDEO', 'RW-HIGHLIGHT', 'SVG']);
export const CLICKABLE_TAGS_THROUGH_PAGINATION_MARGINS = new Set(['A', 'RW-HIGHLIGHT']);

export const PAGINATION_DOCUMENT_TOP_MARGIN = 2000;
